import React from "react";

const WhySection = ({ data }) => {
  // Data Validation from ACF structure
  const whyData = data?.why_section;
  if (!whyData) return null;

  return (
    <section className="sky-why-section sky-ws-content-section">
      {/* Background Cloud Image */}
      {whyData.background_image_url && (
        <img
          src={whyData.background_image_url}
          className="sky-why-bg-img"
          alt="background-cloud"
        />
      )}

      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            {/* Section Main Heading */}
            {whyData.why_heading && (
              <h2 className="sky-why-heading">{whyData.why_heading}</h2>
            )}

            {/* Points List */}
            <div className="sky-why-list">
              {whyData.why_points?.map((point, index) => (
                <div className="sky-why-item" key={index}>
                  {/* Point Icon */}
                  {point.icon_url && (
                    <div className="sky-why-icon-box">
                      <img src={point.icon_url} alt={point.title} />
                    </div>
                  )}

                  {/* Point Title */}
                  <h4 className="sky-why-item-title">{point.title}</h4>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhySection;
